module.exports = __webpack_public_path__ + "static/media/prevention.2847e5db.jpg";